var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combine } from 'zustand/middleware';
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState) { return ({
        setHasUnreadNotifications: function (value) {
            setState(function (state) {
                state.content.hasUnreadNotifications = value;
                return { content: __assign({}, state.content) };
            });
        },
        setHasNewNotifications: function (value) {
            setState(function (state) {
                state.content.hasNewNotifications = value;
                return { content: __assign({}, state.content) };
            });
        },
        reduceBalance: function (value) {
            setState(function (state) {
                state.content.tealBalance -= value;
                return { content: __assign({}, state.content) };
            });
        },
        reduceBenefitBalance: function (value) {
            setState(function (state) {
                state.content.benefitBalance -= value;
                return { content: __assign({}, state.content) };
            });
        },
    }); });
};
